"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const venmoicon = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 38 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-venmoicon` : '') + (description ? ` desc-venmoicon` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-venmoicon"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-venmoicon"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M35.6 0H2.4C1.07452 0 0 1.07452 0 2.4V21.6C0 22.9255 1.07452 24 2.4 24H35.6C36.9255 24 38 22.9255 38 21.6V2.4C38 1.07452 36.9255 0 35.6 0Z",
    fill: "#008CFF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2 7.67948C26.2 11.267 23.206 15.9273 20.7761 19.1998H15.2259L13 5.58527L17.8598 5.11332L19.0367 14.8009C20.1363 12.9685 21.4933 10.0888 21.4933 8.1255C21.4933 7.05084 21.3133 6.31886 21.032 5.71616L25.4576 4.7998C25.9693 5.66429 26.2 6.5547 26.2 7.67948Z",
    fill: "white"
  }));
};
var _default = exports.default = venmoicon;